export default {
  loading (state) {
    return state.loading
  },
  authenticated (state) {
    return state.authenticated
  },
  settings (state) {
    return state.settings
  },
  relation (state) {
    return state.relation
  },
  imporsonate (state) {
    return (state.relation._id != state.settings._id)
  },
  maincontact (state){
    if (!state.contacts || state.contacts.length==0) return {}
    var contact = state.contacts[0]
    if (state.relation._id == state.settings._id) {
      contact = state.settings._user
    } else {
      state.contacts.forEach(function(c){
        contact = c
        if (c.main) return  c
      })
    }
    if (!contact.avatar) contact.avatar = contact.logo || state.relation.logo
    return contact
  },
  tagList (state) {
    return state.settings.tags//.map(t => t.tag)
  },
  user (state) {
    return state.settings._user
  },
  contacts (state) {
    return state.contacts
  },
  role (state) {
    return state.role
  },
  Role: state => role => role.indexOf(state.role) > -1 || role.indexOf('_' + state.settings.role) > -1
}